import store from '@/store';
import S_modulePage from '@/service/api/v1/modulePage';
import H_task from '@/helpers/task';
import H_card from '@/helpers/card';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import H_factoryTag from '@/helpers/factoryTag';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import H_factorySystemClass from '@/helpers/factorySystemClass';

const INDEX_TAG_TYPES = ['status'];

export function mergeMultiSystemSubclasses(system_subclasses, factory_system_subclasses) {
  return (factory_system_subclasses || []).concat(system_subclasses || []);
}

export function getSubTaskMultiSystemSubclasses(subTask, factorySystemClassRows = []) {
  return H_systemClassMenu.formatMultiSystemClassContentChips(
    {
      system_classes: subTask?.system_classes,
      system_subclasses: subTask?.system_subclasses,
      factory_system_classes: subTask?.factory_system_classes,
      factory_system_subclasses: subTask?.factory_system_subclasses,
    },
    { factorySystemClassRows, color: 'medium-blue' },
  );
}

export default {
  mergeMultiSystemSubclasses,
  getSubTaskMultiSystemSubclasses,
  setIndex(rawDataList, factorySystemClassRows = []) {
    return rawDataList.map(({
      id,
      name,
      system_classes,
      system_subclasses,
      factory_system_classes,
      factory_system_subclasses,
      is_collect,
      factory_tags,
      updated_at,
      status,
    }) => ({
      id,
      title: name,
      tags: H_systemClassMenu.formatMultiSystemClassCardTags(
        { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
        { factorySystemClassRows },
      ),
      chips: H_card.setTags({status}, INDEX_TAG_TYPES),
      spec: [
        {
          title: '更新日期',
          text: H_time.getDateDashFormat(updated_at),
        }
      ],
      isCollect: !!is_collect,
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      status,
    }));
  },
  async setSubmitData(rawData) {
    const { taskName: name, taskRemark: remark, taker, factoryTags, links, subTasks } = rawData;
    try {
      const modulePageList = await S_modulePage.index();
      const { system_classes, system_subclasses, factory_system_classes, subtask_factory_templates } = this.setSubmitSubTask(
        subTasks, modulePageList);
      const resultData = {
        name,
        remark,
        taker,
        system_classes,
        system_subclasses,
        factory_system_classes,
        subtask_factory_templates,
        factory_tags: factoryTags[0],
        links: H_task.setSubmitLinks(links, modulePageList),
      };
      return resultData;
    } catch (error) {
      console.error(error);
    }
  },
  setSubmitSubTask(subTasks, modulePageList) {
    const factoryId = store.state.app.factory.id;
    const initial = {
      system_classes: new Set(),
      system_subclasses: new Set(),
      factory_system_classes: new Set(),
      subtask_factory_templates: [],
    };
    const result = subTasks.reduce((acc, subTask, index) => {
      const { id = null, name, remark, links, attaches, multiSystemClasses, taker } = subTask;
      const {
        system_classes,
        system_subclasses,
        factory_system_classes,
      } = H_factorySystemClass.setSubmitModuleData(multiSystemClasses);

      for (const id of system_classes) acc.system_classes.add(id);
      for (const id of system_subclasses) acc.system_subclasses.add(id);
      for (const id of factory_system_classes) acc.factory_system_classes.add(id);

      acc.subtask_factory_templates.push({
        sequence: String(index + 1).padStart(4, '0'),
        factory: factoryId,
        name,
        remark,
        links: H_task.setSubmitLinks(links, modulePageList),
        attaches: H_file.setSubmitInModule(attaches),
        system_classes,
        system_subclasses,
        factory_system_classes,
        taker,
        ...(id && { id }),
      });
      return acc;
    }, initial);
    return {
      system_classes: [...result.system_classes],
      system_subclasses: [...result.system_subclasses],
      factory_system_classes: [...result.factory_system_classes],
      subtask_factory_templates: result.subtask_factory_templates,
    };
  },
  setShow(rawData, subTaskRawData, factorySystemClassRows = []) {
    const {
      name,
      taker,
      remark,
      updated_user,
      updated_at,
      factory_tags,
      links,
      status,
      system_classes,
      system_subclasses,
      factory_system_classes,
      factory_system_subclasses,
      is_collect,
    } = rawData;
    return {
      name,
      taker,
      remark,
      updatedUser: updated_user,
      updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      links: H_task.setShowLinks(links),
      status: this.getStatusText(status),
      multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
        { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
        { factorySystemClassRows },
      ),
      subTasks: this.showIndexSubTask(subTaskRawData, false, factorySystemClassRows),
      isCollect: !!is_collect,
      isDraft: status === 'draft',
    };
  },
  getStatusText(status) {
    const statusText = {
      draft: {text: '草稿', value: 'draft'},
      released: {text: '已發布', color: 'green', value: 'released'},
    };
    return statusText[status] || {text: '', color: ''};
  },
  showIndexSubTask(rawDataList, isUpdate = false, factorySystemClassRows = []) {
    return rawDataList.map(({
      id,
      sequence,
      name,
      remark,
      links,
      attaches,
      system_classes = [],
      system_subclasses = [],
      factory_system_classes = [],
      factory_system_subclasses = [],
      taker,
    }) => {
      const base = {
        id,
        sequence,
        name,
        remark,
        links: H_task.setShowLinks(links),
        attaches: H_file.setShowInModule(attaches),
        taker: taker ? taker.id : null,
        takerValue: taker || {},
        expired_at: '',
      };
      if (isUpdate) {
        return {
          ...base,
          multiSystemClasses: [],
          multiSystemClassesSelectValue: {
            system_classes,
            system_subclasses,
            factory_system_classes,
            factory_system_subclasses,
          },
        };
      }
      return {
        ...base,
        multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
          { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
          { factorySystemClassRows, color: 'medium-blue' },
        ),
      };
    });
  },
  setUpdateShow(rawData, subTaskRawData) {
    const {
      name,
      taker,
      remark,
      factory_tags,
      links,
      status,
      system_subclasses,
      factory_system_subclasses,
    } = rawData;
    return {
      taskName: name,
      taskRemark: remark,
      taker: taker?.id || null,
      takerValue: taker || {},
      factoryTags: [factory_tags.map(tag => tag.id)],
      links,
      status,
      multiSystemSubclasses: mergeMultiSystemSubclasses(system_subclasses, factory_system_subclasses).map(system => system.id),
      subTasks: this.showIndexSubTask(subTaskRawData, true),
    };
  },
  setIndexDataTable(rawDataList) {
    return rawDataList.map(({
      id,
      name,
      system_subclasses,
      taker,
      factory_tags,
    }) => ({
      id,
      taker,
      systemSubclasses: system_subclasses,
      name: {
        text: name,
        chips: H_common.setFactoryTagsInDataTable(factory_tags),
      }
    }));
  },
  setParamsDataTable(filterState) {
    const classes = this.$store.state.model.systemClasses;
    const systemSubclassesLength = (classes || []).flatMap(cls => cls.system_subclasses).length;
    const factorySystemSubclassesLength =
      H_systemClassMenu.countFactorySystemSubclassLeavesFromFilterFields(this.filterFields);
    const { search, systemSubclasses, factorySystemClasses, factoryTags } = filterState;
    const params = {
      status: 'released',
      order_by: 'updated_at',
      order_way: 'desc',
    };

    if (search) params.search = search;
    const systemParam = H_systemClassMenu.toSubclassFilterApiParam(
      systemSubclasses,
      systemSubclassesLength,
    );
    if (systemParam !== undefined) params.system_subclasses = systemParam;
    const factoryParam = H_systemClassMenu.toSubclassFilterApiParam(
      factorySystemClasses,
      factorySystemSubclassesLength,
    );
    if (factoryParam !== undefined) params.factory_system_subclasses = factoryParam;
    if (factoryTags?.length) params.factory_tags = factoryTags.join();

    return params;
  },
  setCreateTaskFromTemplate(rawData, subTaskRawData) {
    const {
      name,
      remark,
      factory_tags,
      links,
      taker,
    } = rawData;
    return {
      taskName: name,
      taskRemark: remark,
      factoryTags: [factory_tags.map(tag => tag.id)],
      links,
      subTasks: this.showIndexSubTask(subTaskRawData, true),
      endData: '',
      taker: taker?.id || null,
      takerValue: taker || {},
      subTaskVisibility: 'taker',
    };
  },
};
